import React from 'react'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'
import Bus from 'EurestoClass/Bus'

export default class extends React.Component {
  constructor (props) {
    super(props)
  }

  componentDidMount () {
    this.props.element().on('DOMMouseScroll', this.onScroll)
    this.props.element().on('wheel', this.onScroll)
  }

  componentWillUnmount () {
    this.props.element().off('DOMMouseScroll', this.onScroll)
    this.props.element().off('wheel', this.onScroll)
  }

  onScroll = _ => {
    if (
      ((this.props.element() && this.props.element().scrollTop() + this.props.element().innerHeight() + .5) >= this.props.element()[0].scrollHeight) &&
      !this.props.over &&
      !this.props.isLoading
    ) {
      Bus.$emit('infinityScroll_search_' + this.props.search, true)
    }
  }

  render () {
    return <Grid container style={{ margin: 0, padding: 0 }} spacing={0} alignItems={'center'} justify={'center'}>
      {
        this.props.showLoader && this.props.isLoading && <CircularProgress size={20} thickness={4} className={'EurestoPrimary--text'}/>
      }
    </Grid>
  }
}



// WEBPACK FOOTER //
// ./app/Components/InfinityScroll.js